import { useRef, useState } from 'react';
import styles from './ChecklistRows.module.css';
import { TableCell, Checkbox, IconButton } from 'components/mui';
import ChecklistEditor from '../../checklistEditor/ChecklistEditor';
import { AddIcon, RemoveIcon } from 'components/icons';
import ChecklistAssignedPatrolInfo from '../../AlertDialog/ChecklistAssignedPatrolInfo';
import AssignedPatrolButton from 'containers/pages/checklists/utils/AssignedPatrolButton';
import ChecklistTypes from 'containers/pages/checklists/constants/checklistTypes';
import PreviewIncidentReportButton from 'containers/pages/checklists/utils/PreviewIncidentReportButton';

const ChecklistRows = ({ checklist, onSelectChecklistID, setChecklists }) => {
	const [openInEditMode, setOpenInEditMode] = useState(false);
	const [showAssignedPatrols, setShowAssignedPatrols] = useState(false);
	const saveRef = useRef();

	function onEditModeClick() {
		if (openInEditMode) {
			if (saveRef.current) {
				const hasChanges = saveRef.current.checkForUnsavedChanges();
				if (hasChanges) {
					return;
				}
			}
		}

		setOpenInEditMode((prevState) => {
			return !prevState;
		});
	}

	const infoModalHandler = {
		onCancel: () => setShowAssignedPatrols(false),
		onBack: () => setShowAssignedPatrols(false),
	};

	return (
		<>
			<TableCell className={styles.editModeCell1}>
				<IconButton
					aria-label="expand row"
					size="small"
					onClick={onEditModeClick}
				>
					{openInEditMode ? <RemoveIcon /> : <AddIcon />}
				</IconButton>
			</TableCell>
			<TableCell align="left" className={styles.editModeCell1}>
				<Checkbox
					checked={checklist?.isSelected || false}
					onChange={() => onSelectChecklistID(checklist.ChecklistID)}
				/>
			</TableCell>
			{!openInEditMode ? (
				<>
					<TableCell align="left">{checklist.Name}</TableCell>
					<TableCell align="left">{checklist.Description}</TableCell>
					<TableCell align="right" colSpan={1}>
						{checklist.Type === ChecklistTypes.Patrol && (
							<AssignedPatrolButton
								numberOfAssignedPatrols={
									checklist.AssignedPatrols.length
								}
								setShowAssignedPatrols={setShowAssignedPatrols}
							/>
						)}
						{checklist.Type === ChecklistTypes.Incident && (
							<PreviewIncidentReportButton
								checklistID={checklist.ChecklistID}
							/>
						)}
					</TableCell>
				</>
			) : (
				<TableCell align="left" colSpan={12}>
					<ChecklistEditor
						checklist={checklist}
						setChecklists={setChecklists}
						setOpenInEditMode={setOpenInEditMode}
						saveRef={saveRef}
						setShowAssignedPatrols={setShowAssignedPatrols}
					/>
				</TableCell>
			)}
			{showAssignedPatrols && (
				<ChecklistAssignedPatrolInfo
					patrols={checklist.AssignedPatrols}
					handler={infoModalHandler}
				/>
			)}
		</>
	);
};
export default ChecklistRows;
